
define('text!templates/appMain/privilegedMain/listDetailsMain.html',[],function () { return '<!-- ko switchedInclude: {\n    viewModel: subViews,\n    mappings: {\n        listContainerView: \'templates/appMain/privilegedMain/listContainerView\',\n        detailsContainerView: \'templates/appMain/privilegedMain/detailsContainerView\'\n    }\n} --><!-- /ko -->\n';});

